import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { inferQueryKeys } from '@lukemorales/query-key-factory';
import type { User } from '~/types/auth';

export const users = createQueryKeys('users', {
  me: null,
  membership: null,
  details: (userId: User['id']) => [userId],
  agent: (userId: User['id']) => [userId],
  appointments: (userId: User['id'], params?: { page?: number; limit?: number; status?: string; range?: string }) => [
    userId,
    params,
  ],
  allPaginated: (query?: any) => [query],
  assignableManagers: null,
  teamAssignableManagers: null,
});

export type CountryKeys = inferQueryKeys<typeof users>;
